export default {
  AccJobStatus: {
    0: '新工作号',
    1: '待销售审核',
    2: '待部门经理审核',
    3: '待总经理审核',
    4: '待VP审核',
    6: '待财务关账',
    7: '当月更正',
    8: '已作废',
    9: '已关账'
  },
  JobTypeEnum: {
    OE: '海出',
    LE: '出口拼箱',
    OI: '海进',
    LI: '进口拼箱',
    TE: '外贸',
    MM: '内贸水运',
  },
  JobTypeEnumEN: {
    OE: 'Ocean Export',
    LE: 'Console Export',
    OI: 'Ocean Import',
    LI: 'Conslone Import',
    TE: '外贸',
    MM: 'Multi-Trans',
  }
}
